module.exports = __webpack_public_path__ + "static/media/1f44b.f73e1854.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f44b.svg
// module id = 623
// module chunks = 1